var _image;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "28px",
    height: "36px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    x: "0px",
    y: "0px",
    width: "28px",
    height: "36px",
    xlinkHref: "data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAkCAQAAAAwLZLfAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfoBhIQLjkLt3uvAAAAu0lEQVRIx+XVwQ3CMAwF0F/EIGYyM0kZpaNkFLqJe6AkToljtxIIRHJolfQdYiu/EKhJnK5JqFoz5oZBIDH6wqK0wWK0ySLUYD41mUdhs5UaW4MQ8hjuj6dcyhpmtIfu4/Ml0scTDo7Pw3PgG1W+UqoIbFb7h4rzD7DqY3UrdsD5u8/4httBzqoVDf0Q6+12YpNTyacdlJOQoAeblNeQ9mJwQzlnu5ufmrL6Jfgw09ukgzoCIcRpGut8XwBgkutJYwalawAAAABJRU5ErkJggg=="
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRate);
export default __webpack_public_path__ + "static/media/Rate.9617bcd8e977ee6c5dfa12162e4aaf5e.svg";
export { ForwardRef as ReactComponent };